import { render, staticRenderFns } from "./checkoutItem.vue?vue&type=template&id=a9a2710a&scoped=true"
import script from "./checkoutItem.vue?vue&type=script&lang=js"
export * from "./checkoutItem.vue?vue&type=script&lang=js"
import style0 from "./checkoutItem.vue?vue&type=style&index=0&id=a9a2710a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a2710a",
  null
  
)

export default component.exports